import { Icon } from '@ascend/shared/components';
import { LiquidationQueueTable } from '../components/LiquidationQueueTable';

export function LiquidationPage() {
  return (
    <div className="space-y-6 sm:space-y-8">
      <div className="flex items-start gap-3">
        <Icon name="streamline:legal-justice-hammer-hammer-work-legal-mallet-office-company-gavel-justice-judge-arbitration-court" className="mt-1 h-6 w-6 sm:h-7 sm:w-7 text-foreground flex-shrink-0" />
        <div>
          <h1 className="text-xl sm:text-2xl font-bold">Liquidation Monitor</h1>
          <p className="text-sm text-muted-foreground">
            Monitor positions at risk across all credit facilities. DDF liquidation
            is auto-triggered by searchers — this page is read-only.
          </p>
        </div>
      </div>

      <LiquidationQueueTable
        title="Positions at Risk"
        description="Accounts nearing or below liquidation threshold. DDF liquidation runs automatically for facilities with DDF resolution enabled, triggered by searchers monitoring health factors."
      />
    </div>
  );
}
